<script setup lang="ts">
import '@/utils/floorUtils.ts';

import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

import NumberRangeComponent from '@/components/filters/NumberRange.vue';
import { formatCurrencyWithoutDecimal } from '@/helpers/currencyHelper.ts';
import type { LocaleSchema } from '@/locales/index';
import type { NumberRange } from '@/typings/NumberRange';

const props = defineProps<{
  maxValue: number,
  minValue: number,
  subtitle?: string,
  step?: number
}>();

const modelValue = defineModel<NumberRange | undefined>();

const { t, locale } = useI18n<{ message: LocaleSchema }>({
  useScope: 'global',
});

function tooltipFormatter(value: number) {
  return formatCurrencyWithoutDecimal(value, locale);
};

watch(modelValue, (newValue) => {
  if (newValue?.min === props.minValue && newValue?.max === props.maxValue) {
    modelValue.value = undefined;
  }
}, { immediate: true });
</script>

<template>
  <fieldset>
    <legend>{{ t('forms.units.filters.unitPrice.title') }}</legend>
    <p>{{ props.subtitle || t('forms.units.filters.unitPrice.subTitle') }}</p>
    <NumberRangeComponent v-model="modelValue"
                          :allow-manual-inputs="true"
                          :min-value="props.minValue"
                          :max-value="props.maxValue"
                          :step="props.step || 5000"
                          input-format="currency"
                          :slider-format="tooltipFormatter"
                          integer />
  </fieldset>
</template>
